// extracted by mini-css-extract-plugin
module.exports = {"mainPageConatiner":"MainPage_mainPageConatiner__2yHGo","mainPageTitle":"MainPage_mainPageTitle__2ej0P","mainPageActions":"MainPage_mainPageActions__1kGjr"};